<template>
  <el-dialog
    :title="`${$t('人员选择')}`"
    v-dialogDrag
    :visible.sync="dialogVisible"
    class="small-dialog"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-row class="h-full">
      <el-col :span="12" class="h-full">
        <div class="mr-10px h-full">
          <el-card class="h-full">
            <el-row class="mb-10px flex">
              <el-input
                :placeholder="`${$t('请输入')}`"
                class="inline-block"
                prefix-icon="el-icon-search"
                v-model="directoryTreeKeyWords"
                clearable
              />
              <el-button type="primary" class="ml-6px" @click="searchTree">{{
                $t('搜索')
              }}</el-button>
            </el-row>
            <el-row class="tree-box">
              <el-tree
                highlight-current
                show-checkbox
                :data="treeData"
                v-loading="treeLoading"
                :props="defaultProps"
                ref="treeRef"
                :render-after-expand="false"
                node-key="keyId"
                :filter-node-method="treeFilterMethod"
                :default-checked-keys="defaultCheckedList"
                @check-change="checkNodeChange"
                class="min-h-300px max-h-full overflow-auto"
              >
                <div slot-scope="{ node, data }" class="flex items-center w-full text-14px">
                  <i class="iconfont icon-line-folder text-14px mr-5px" v-if="data.childen"></i>
                  <p class="flex-1">
                    {{ node.label }}
                  </p>
                  <span v-if="data.userList">{{ data.userList.length }}</span>
                </div>
              </el-tree>
            </el-row>
          </el-card>
        </div>
      </el-col>
      <el-col :span="12" class="h-full">
        <div class="h-60px !leading-60px text-16px font-weight">
          <span>已选择：{{ selectedNodeList.length }}</span>
        </div>
        <div class="people-list overflow-auto">
          <div v-for="nodeItem in selectedNodeList" :key="nodeItem.keyId" class="flex mt-10px">
            <span class="mr-10px iconfont icon-bg-me text-16px"></span>
            <span class="flex-1 mr-10px text-16px">{{ nodeItem.name }}</span>
            <span class="cursor-pointer text-16px" @click="deleteSelected(nodeItem)">X</span>
          </div>
        </div>
        <div class="mt-20px flex justify-center">
          <el-button type="primary" size="small" @click="createMember">{{ $t('创建') }}</el-button>
          <el-button size="small" @click="clearSelected">{{ $t('清空') }}</el-button>
          <el-button size="small" @click="dialogVisible = false">{{ $t('取消') }}</el-button>
        </div>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { EafOrganizationUnitUserApi } from '@wiz-api/account'

const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()
export default {
  name: 'selectPerson',
  props: {
    isMultiple: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    }, // 弹窗显隐
    selectedPersonList: {
      type: Array,
      default: () => {
        return []
      },
    }, // 默认已选中人员
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  created() {
    // const selectedKeyIds = _.map(this.selectedPersonList, 'keyId')
    // this.defaultCheckedList = selectedKeyIds.flat(1)
    this.getUserTree()
  },
  data() {
    return {
      directoryTreeKeyWords: '', // 目录树搜索关键字
      treeData: [], // 目录树数据
      treeLoading: false, // 目录树loading
      defaultProps: {
        children: 'childen',
        label: 'name',
      }, // 目录树默认配置
      selectedNodeList: [], // 目录树已勾选节点
      defaultCheckedList: [], // 目录树默认勾选
    }
  },
  methods: {
    /**
     * @description 获取组织机构和人员
     */
    async getUserTree() {
      this.treeLoading = true
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserTree({
        outputPost: true,
        isActive: true
      })
      this.treeLoading = false
      if (!err) {
        this.treeData = res
        this.dealUserTree(this.treeData)
        this.initCheckTree()
      }
    },

    /**
     * @description 目录树子节点数据调整
     * @param {Array} treeData
     */
    dealUserTree(treeData) {
      _.forEach(treeData, (treeItem) => {
        if (treeItem.childen) {
          treeItem.keyId = treeItem.organizationUnitId
          treeItem.name = treeItem.organizationUnitName
          if (treeItem.userList) {
            _.forEach(treeItem.userList, (userItem) => {
              userItem.keyId = treeItem.organizationUnitId + userItem.id
              userItem.organizationUnitId = treeItem.organizationUnitId
              userItem.organizationUnitName = treeItem.organizationUnitName
            })
            treeItem.childen.push(...treeItem.userList)
          }
          this.dealUserTree(treeItem.childen)
        }
      })
    },

    /**
     * @description 获取目录树下不同组织下的同一人员(id相同)
     * @param {Array} treeData
     * @param {String} keyId 需查询的人员id
     * @returns personList
     */
    getPerson(treeData, keyId) {
      const personList = []
      _.forEach(treeData, (treeItem) => {
        if (treeItem.childen) {
          const resultList = this.getPerson(treeItem.childen, keyId)
          personList.push(...resultList)
        }
        if (treeItem.userList) {
          _.forEach(treeItem.userList, (userItem) => {
            if (userItem.id === keyId) {
              personList.push(userItem)
            }
          })
        }
      })
      return personList
    },

    /**
     * @description 初始化目录树默认勾选人员
     */
    initCheckTree() {
      this.$nextTick(() => {
        const keyIds = []
        const selectedKeyIds = _.map(this.selectedPersonList, 'keyId')
        const selectedNodeList = []
        selectedKeyIds.forEach((item) => {
          const data = this.$refs.treeRef?.getNode(item)?.data
          if (!data) return
          const singleData = this.getPerson(this.treeData, data.id)
          if (singleData.length) {
            const props = _.map(singleData, 'keyId')
            singleData.forEach((val) => {
              val.keyIds = props
              keyIds.push(val.keyId)
            })
            selectedNodeList.push(singleData[0])
          }
        })
        this.$refs.treeRef?.setCheckedKeys(keyIds)
        this.selectedNodeList = selectedNodeList
      })
    },

    /**
     * @description 目录树搜索
     */
    searchTree() {
      this.$refs.treeRef.filter(this.directoryTreeKeyWords)
    },

    /**
     * @description 目录树过滤
     */
    treeFilterMethod(value, data) {
      if (!value) return true
      return data.name && data.name.indexOf(value) !== -1
    },

    /**
     * @description 目录树节点勾选变化
     */
    checkNodeChange(data, isCheck) {
      if (isCheck) {
        // 勾选
        if (data.childen) return
        const findIndex = _.findIndex(this.selectedNodeList, (selectedItem) => {
          return selectedItem.keyIds?.includes(data.keyId)
        })
        if (findIndex === -1) {
          // 不同组织下的同一人员，也需勾选
          const repeatPersonList = this.getPerson(this.treeData, data.id)
          this.selectedNodeList.push({
            ...data,
            organizationUnitIdList: _.map(repeatPersonList, 'organizationUnitId'), // 记录所有不同组织下的同一人员的组织
            organizationUnitNameList: _.map(repeatPersonList, 'organizationUnitName'), // 记录所有不同组织下的同一人员的组织
            keyIds: _.map(repeatPersonList, 'keyId'), // 记录所有不同组织下的同一人员的keyId
          })

          _.forEach(repeatPersonList, (personItem) => {
            if (personItem.keyId === data.keyId) return
            this.$refs.treeRef && this.$refs.treeRef.setChecked(personItem.keyId, true)
          })
        }
      } else {
        // 取消勾选
        if (data.childen) return
        const findIndex = _.findIndex(this.selectedNodeList, (selectedItem) => {
          return selectedItem.keyIds?.includes(data.keyId)
        })
        if (findIndex !== -1) {
          this.selectedNodeList.splice(findIndex, 1)
          // 不同组织下的同一人员，也需取消勾选
          const repeatPersonList = this.getPerson(this.treeData, data.id)
          _.forEach(repeatPersonList, (personItem) => {
            if (personItem.keyId === data.keyId) return
            this.$refs.treeRef && this.$refs.treeRef.setChecked(personItem.keyId, false)
          })
        }
      }
    },

    /**
     * @description 创建人员选择
     */
    createMember() {
      this.$emit('getSelectedList', this.selectedNodeList)
      this.dialogVisible = false
    },

    /**
     * @description 清空已勾选
     */
    clearSelected() {
      this.selectedNodeList = []
      this.defaultCheckedList = []
      this.$refs.treeRef && this.$refs.treeRef.setCheckedKeys([])
    },

    /**
     * @description 删除已勾选
     * @param {Object} deleteItem 删除项数据
     */
    deleteSelected(deleteItem) {
      const deleteIndex = _.findIndex(this.selectedNodeList, (selectedItem) => {
        return selectedItem.keyId === deleteItem.keyId
      })
      if (deleteIndex !== -1) {
        this.selectedNodeList.splice(deleteIndex, 1)
        const repeatPersonList = this.getPerson(this.treeData, deleteItem.id)
        _.forEach(repeatPersonList, (personItem) => {
          this.$refs.treeRef && this.$refs.treeRef.setChecked(personItem.keyId, false)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  text-align: right;
}
::v-deep .el-card__body {
  height: 100%;
}
.people-list {
  height: calc(100% - 116px);
}
.tree-box {
  height: calc(100% - 46px);
}
</style>
